import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../consts/api";

export const useSunbitCapabilities = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.sunbit.getCapabilities],
    () => http.get(HTTP_ENDPOINTS.sunbit.getCapabilities()),
    { cacheTime: 0, select: (data) => data.data.data, ...options },
  );

  return res;
};
